import { render, staticRenderFns } from "./EditTrainingProgramForm.vue?vue&type=template&id=b6d1fbaa&scoped=true&"
import script from "./EditTrainingProgramForm.vue?vue&type=script&lang=js&"
export * from "./EditTrainingProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d1fbaa",
  null
  
)

export default component.exports